import React, { useState } from 'react';
import { useTheme } from '../context/ThemeContext';
import SideMenu from '../components/SideMenu';
import { useTranslation } from 'react-i18next';

const IFRAME_SOURCES = [
  'https://fs.filuet.com/grafana/d/adsjqvp/main?orgId=1&from=now-6h&to=now&timezone=browser',
  'https://fs.filuet.com/jaeger/',
  'https://fs.filuet.com/flower/tasks'
];

export default function Observability() {
  const { currentTheme, theme } = useTheme();
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);

  const tabKeys = ['observabilityTabGrafana', 'observabilityTabJaeger', 'observabilityTabFlower'];

  return (
    <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: currentTheme.background }}>
      <SideMenu currentTheme={currentTheme} theme={theme} />

      <main
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
          minWidth: 0,
          padding: 24,
          boxSizing: 'border-box'
        }}
      >
        <h1 style={{ marginTop: 0, marginBottom: 16, color: currentTheme.text }}>{t('observability')}</h1>

        <div
          role="tablist"
          aria-label={t('observability')}
          style={{
            display: 'flex',
            gap: 4,
            borderBottom: `1px solid ${currentTheme.border}`,
            marginBottom: 16,
            flexShrink: 0
          }}
        >
          {tabKeys.map((key, index) => {
            const selected = activeTab === index;
            return (
              <button
                key={key}
                type="button"
                role="tab"
                id={`observability-tab-${index}`}
                aria-selected={selected}
                aria-controls={`observability-panel-${index}`}
                tabIndex={selected ? 0 : -1}
                onClick={() => setActiveTab(index)}
                style={{
                  padding: '10px 16px',
                  marginBottom: -1,
                  border: '1px solid transparent',
                  borderBottomColor: selected ? currentTheme.surface : 'transparent',
                  borderRadius: '8px 8px 0 0',
                  background: selected ? currentTheme.surface : 'transparent',
                  color: selected ? currentTheme.text : currentTheme.textSecondary,
                  fontSize: 14,
                  fontWeight: selected ? 600 : 400,
                  cursor: 'pointer',
                  boxShadow: selected ? currentTheme.cardShadow : 'none'
                }}
              >
                {t(key)}
              </button>
            );
          })}
        </div>

        <div
          style={{
            flex: 1,
            minHeight: 0,
            borderRadius: 8,
            overflow: 'hidden',
            border: `1px solid ${currentTheme.border}`,
            background: currentTheme.surface,
            boxShadow: currentTheme.cardShadow
          }}
        >
          {IFRAME_SOURCES.map((src, index) => (
            <div
              key={src}
              id={`observability-panel-${index}`}
              role="tabpanel"
              aria-labelledby={`observability-tab-${index}`}
              hidden={activeTab !== index}
              style={{
                width: '100%',
                height: '100%',
                minHeight: 480,
                display: activeTab === index ? 'flex' : 'none'
              }}
            >
              <iframe
                title={t(tabKeys[index])}
                src={src}
                style={{
                  flex: 1,
                  width: '100%',
                  border: 0,
                  minHeight: 0
                }}
              />
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
